export default "__VITE_ASSET__BA_Ge0iE__"